/*eslint-disable*/export const messages=JSON.parse("{\"toggle.label.optional\":[\"(valgfrit)\"]}");